import { FormField } from './FormField';
import type { SelectOption } from './selectTypes';

type Props = {
  label: string;
  name: string;
  options: SelectOption[];
  value: string;
  onChange: (value: string) => void;
  errors?: string[];
};

/** `FormField` with a vertical group of radio buttons. */
export const RadioGroupField = ({ label, name, options, value, onChange, errors }: Props) => (
  <FormField label={label} errors={errors}>
    {options.map((option) => (
      <div className="radio" key={option.value}>
        <label>
          <input
            type="radio"
            name={name}
            value={option.value}
            checked={value === option.value}
            onChange={() => onChange(option.value)}
          />
          {option.label}
        </label>
      </div>
    ))}
  </FormField>
);
